import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Menu } from '../ndm/models/menu.model';
import { MasterService } from '../services/masters.service';
import { NotificationService } from '../services/notification.service';
import { SharedService } from '../services/shared.service';
import { LoaderService } from '../shared/loader/loader.service';

@Component({
    selector: 'app-common-layout',
    templateUrl: 'common-layout.component.html',
    styleUrls: ['common-layout.component.css'],
    standalone: false
})
export class CommonlayoutComponent implements OnInit {
  menuList: Subject<Menu> = new Subject();
  showHideMenuIcon: boolean = false;
  loadSideNav: boolean = false;
  isExpanded: boolean = false;
  constructor( 
    private router: Router,
    private masterService: MasterService,
    private sharedService: SharedService,
    private toast: NotificationService,
    private loader: LoaderService,
  ) {
  }

  handleMenuEvent(event: any) {
    this.isExpanded = event;
  }

  ngOnInit(): void {
    this.getMenuDetails();
  }

  getMenuDetails() {
    this.masterService.getMenu().subscribe(res => {
      this.sharedService.menuList.next(res);
    },
    (error: any) => {
      this.loader.stop();
      this.toast.showException(error.error);
    }
  );
  }
}
